import React,{useState} from "react";
import { useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo/logo.png";
import "../../assets/css/callback/callback.css";
const CallbackPaiement = () => {
  const navigate = useNavigate();
  const [isFree, setIsFree] = useState(process.env.REACT_APP_IS_FREE);
  return (
    <div className="container">
      <div className="callback_header">
        <img src={logo} alt="logo deal.mg" className="callback_logo"/>
        <i
          className="bi bi-x-circle"
          role="button"
          onClick={() => navigate("/")}
        ></i>
      </div>
      <div className="callback_content">
        <i class="bi bi-check-circle-fill"></i>
        {
          isFree ==1 ? <h1>Votre annonce a été publiée !</h1> : <h1>Paiement en cours, vous allez recevoir un notification dans un instant.</h1>
        }
        <span onClick={() => navigate("/utilisateur/mesAnnonces")} role="button">Mes annonces</span>
      </div>
    </div>
  );
};

export default CallbackPaiement;
